// Module Federation async boundary. The entry must consume NO shared
// singleton synchronously, so it only dynamically imports bootstrap — which
// pre-loads config + Sentry (top-level await) then imports main.tsx where
// React/store/DS/i18n (shared singletons) are used. Avoids loadShareSync /
// RUNTIME-006.
import('./bootstrap');

export {};
